import { render, staticRenderFns } from "./PromotionCard.vue?vue&type=template&id=4786ed55&scoped=true"
import script from "./PromotionCard.vue?vue&type=script&lang=js"
export * from "./PromotionCard.vue?vue&type=script&lang=js"
import style0 from "./PromotionCard.vue?vue&type=style&index=0&id=4786ed55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786ed55",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
